import Image from "next/image";

export default function MenuEachLink({
  item,
  nowSection,
  handleScrollTo,
  color,
  isMerchantPage,
}) {
  const fontColor = {
    color: item.section === nowSection ? color : "",
  };

  return (
    <li
      key={item.id}
      className={`${isMerchantPage ? "menu-merchant-li" : "menu-list-li"} `}
    >
      <button
        className="flex items-center  w-full justify-between"
        onClick={() => handleScrollTo(item.section)}
      >
        <div
          style={fontColor}
          className="flex gap-2 max-md:gap-4 font-medium items-center text-[1rem] max-md:text-2xl hover:opacity-80"
        >
          <figure className="w-8 max-md:w-12">
            <Image
              src={item.img}
              width={55}
              height={55}
              className={item.section === nowSection ? "" : "grayscale"}
              alt={item.content}
              priority
            />
          </figure>

          {item.content}
        </div>
        <figure className="w-8 max-md:w-10">
          <Image
            src="/assets/elements/menu_arrow.png"
            width={50}
            height={50}
            className="arrow"
            alt={item.content}
            priority
          />
        </figure>
      </button>
    </li>
  );
}
